import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiChevronDown, FiChevronUp } = FiIcons;

const RatingBar = ({ label, rating }) => (
  <div className="flex items-center justify-between gap-4 w-full">
    <span className="text-sm text-gray-700 font-medium whitespace-nowrap">{label}</span>
    <div className="flex items-center gap-3 w-full max-w-[200px]">
      <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden">
        <div 
          className="h-full bg-gray-900 rounded-full" 
          style={{ width: `${(rating / 5) * 100}%` }} 
        />
      </div>
      <span className="text-xs font-bold text-gray-900 min-w-[20px]">{rating.toFixed(1)}</span>
    </div>
  </div>
);

const ReviewCard = ({ name, date, avatar, text }) => (
  <div className="py-6 border-b border-gray-50 last:border-0">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 font-bold text-sm">
        {avatar || name.charAt(0)}
      </div>
      <div>
        <h4 className="text-sm font-bold text-gray-900">{name}</h4>
        <p className="text-xs text-gray-500">{date}</p>
      </div>
    </div>
    <p className="text-sm text-gray-600 leading-relaxed">
      {text}
    </p>
  </div>
);

export default function ReviewsSection() {
  const [showAll, setShowAll] = useState(false);

  const stats = [
    { label: "Cleanliness", rating: 4.9 },
    { label: "Accuracy", rating: 4.8 },
    { label: "Communication", rating: 5.0 },
    { label: "Location", rating: 4.9 },
    { label: "Check-in", rating: 4.9 },
    { label: "Value", rating: 4.7 }
  ];

  const allReviews = [
    {
      name: "Camila R.",
      date: "October 2023",
      text: "The location is unbeatable if you're attending an event at Movistar Arena. The loft was spotless and the views of the park are amazing. John was very responsive."
    },
    {
      name: "Mark T.",
      date: "September 2023",
      text: "Great stay! The building staff is very professional. The coworking space was perfect for my remote meetings. Highly recommend for business travelers."
    },
    {
      name: "Alejandro M.",
      date: "August 2023",
      text: "Excelente apartamento. Muy moderno y cómodo. La cocina está muy bien equipada. Volveré sin duda en mi próximo viaje a Bogotá."
    },
    {
      name: "Sofia G.",
      date: "July 2023",
      text: "Perfect location for Estéreo Picnic. We walked back after the concert and felt very safe. The bed is very comfortable."
    },
    {
      name: "Daniela P.",
      date: "June 2023",
      text: "The pool and gym are fantastic. Make sure to book them in advance. The view from the 8th floor is breathtaking at sunset."
    }
  ];

  const displayedReviews = showAll ? allReviews : allReviews.slice(0, 3);

  return (
    <section className="mt-8">
      <div className="flex items-center gap-2 mb-8">
        <SafeIcon icon={FiStar} className="text-emerald-600 text-xl" />
        <h3 className="text-xl font-bold text-gray-900">4.88 · 48 reviews</h3>
      </div>

      {/* Ratings Breakdown Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-4 mb-12">
        {stats.map((stat, idx) => (
          <RatingBar key={idx} {...stat} />
        ))}
      </div>

      {/* Reviews List */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16">
        {displayedReviews.map((review, idx) => (
          <ReviewCard key={idx} {...review} />
        ))}
      </div>

      {allReviews.length > 3 && (
        <button 
          onClick={() => setShowAll(!showAll)}
          className="mt-8 px-6 py-3 border border-gray-900 rounded-xl font-bold text-sm hover:bg-gray-50 transition-colors flex items-center gap-2"
        >
          {showAll ? 'Show fewer reviews' : `Show all ${allReviews.length} reviews`}
          <SafeIcon icon={showAll ? FiChevronUp : FiChevronDown} />
        </button>
      )}
    </section>
  );
}